import Image from "next/image";
import BrevoForm from "./brevoForm";

const NewsletterForm = ({ onClose }) => {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-lg p-5 relative max-w-[500px] mx-4 max-h-[95vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-0.5 right-2 text-[30px] leading-none"
          aria-label="Close"
        >
          &times;
        </button>
        <div className="flex flex-col justify-center gap-5 text-[14px]">
          <div className="flex flex-row items-center gap-5">
            <Image
              src="images/x-rabatt.svg"
              alt="?? € Rabatt"
              className="w-[80px]"
              width={80}
              height={80}
            />
            <div className="flex flex-col">
              <h3 className="text-[18px] font-bold">Fotobox Gutscheine</h3>
              <div className="text-[16px] leading-5">
                Melde dich an und erhalte{" "}
                <strong>exklusive Fotobox Gutscheine</strong> verschiedener
                Fotobox-Anbieter.
              </div>
            </div>
          </div>
          <div className="flex flex-row text-left gap-5">
            <div className="flex flex-col text-[16px]">
              <BrevoForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterForm;
